import {initEmailMarketingCampaignPerformance, removeInvalidEmailsForCampaign, removeInvalidEmailsForMailingList} from "@Components/email-marketing-campaign-performance/email-marketing-performance-thunk.js";
import {getFirstSelectedItemId, LOADING_STATES, updateWindowLocationHash} from "@Libraries/email-marketing-campaigns-library.js";

export const emailMarketingCampaignPerformanceExtraReducers = (builder) => {
    builder.addCase(initEmailMarketingCampaignPerformance.pending, (state) => {
        state.performanceLoadingState = LOADING_STATES.LOADING;
    });

    builder.addCase(initEmailMarketingCampaignPerformance.fulfilled, (state, {payload}) => {
        state.campaigns = payload.campaigns;
        state.campaignsWithMetricsAvailable = payload.campaignsWithMetricsAvailable;
        state.campaignsWithMetricsNotAvailable = payload.campaignsWithMetricsNotAvailable;
        state.campaignsWithMetricsCollecting = payload.campaignsWithMetricsCollecting;
        state.campaignMetrics = payload.campaignMetrics;
        state.mailingLists = payload.mailingLists;
        state.mailingListsWithAvailableMetrics = payload.mailingListsWithAvailableMetrics;
        state.mailingListsWithMetricsNotAvailable = payload.mailingListsWithMetricsNotAvailable;
        state.mailingListsWithMetricsCollecting = payload.mailingListsWithMetricsCollecting;
        state.mailingListMetrics = payload.mailingListMetrics;
        state.itemType = payload.itemType;
        state.selectedItemIds = payload.selectedItemIds;
        state.isNoCampaignCreated = payload.isNoCampaignCreated;
        state.isNoCampaignPublished = payload.isNoCampaignPublished;
        state.isCollectingData = payload.isCollectingData;
        state.isNoMailingListCreated = payload.isNoMailingListCreated;
        state.isNotCollectingData = payload.isNotCollectingData;
        state.performanceLoadingState = LOADING_STATES.LOADED;
        updateWindowLocationHash(state.itemType, state.selectedItemIds);
    });

    builder.addCase(removeInvalidEmailsForCampaign.pending, (state) => {
        state.performanceLoadingState = LOADING_STATES.LOADING;
    });

    builder.addCase(removeInvalidEmailsForCampaign.fulfilled, (state, {meta}) => {
        const {emails} = meta.arg;
        state.performanceLoadingState = LOADING_STATES.LOADED;

        emails.forEach(email => {
            state.campaignMetrics[getFirstSelectedItemId(state.selectedItemIds)]['details'][email].isDeleted = true;
        })
    });

    builder.addCase(removeInvalidEmailsForMailingList.pending, (state) => {
        state.performanceLoadingState = LOADING_STATES.LOADING;
    });

    builder.addCase(removeInvalidEmailsForMailingList.fulfilled, (state) => {
        state.performanceLoadingState = LOADING_STATES.LOADED;
        state.mailingListMetrics[getFirstSelectedItemId(state.selectedItemIds)]['insights'][payload].isDeleted = true;
    });
}